export default "__VITE_ASSET__DHtJlC8C__"